module.exports = __webpack_public_path__ + "img/arrow_left.2a7af464.png";